import { render, staticRenderFns } from "./OrgElementComponentVerantwortungen.vue?vue&type=template&id=c6255a1a&lang=pug"
import script from "./OrgElementComponentVerantwortungen.vue?vue&type=script&lang=js"
export * from "./OrgElementComponentVerantwortungen.vue?vue&type=script&lang=js"
import style0 from "vue-multiselect/dist/vue-multiselect.min.css?vue&type=style&index=0&prod&lang=css&external"
import style1 from "./OrgElementComponentVerantwortungen.vue?vue&type=style&index=1&id=c6255a1a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports